import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map, switchMap } from 'rxjs/operators';

import { TranslateService } from 'src/app/core/services/translate/translate.service';

import { injectCatchHttpError } from '../../../core/errors/catch-http-error.util';
import { ApiAuthService } from '../../services/api-auth.service';
import {
  forgotPassword,
  forgotPasswordCreateTranslatedMessage,
  forgotPasswordFailure,
  forgotPasswordSuccess,
} from './forgot-password.actions';

@Injectable()
export class ForgotPasswordEffects {
  private apiAuth = inject(ApiAuthService);
  private translate = inject(TranslateService);

  private readonly actions$ = inject<Actions>(Actions);
  private readonly catchHttpError = injectCatchHttpError();

  forgotPassword$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPassword),
      map(action => action.forgotPasswordData),
      exhaustMap(forgotPasswordData =>
        this.apiAuth.forgotPassword(forgotPasswordData).pipe(
          map(() => forgotPasswordSuccess({ forgotPasswordData })),
          this.catchHttpError(error => forgotPasswordFailure({ error })),
        ),
      ),
    ),
  );

  translateMessage$ = createEffect(() =>
    this.actions$.pipe(
      ofType(forgotPasswordSuccess),
      map(action => action.forgotPasswordData),
      switchMap(forgotPasswordData => {
        const message = this.translate.instant('FORGOT_PASSWORD.NOTIFICATION_MESSAGE', { value: forgotPasswordData.email });
        return [forgotPasswordCreateTranslatedMessage({ message })];
      }),
    ),
  );
}
